/* eslint-disable jsx-a11y/label-has-associated-control */
import TableWrapper from 'components/common/table-wrapper/TableWrapper'
import { alertTypes, initialMetaForTable } from 'constants/Common'
import React, { useEffect, useState } from 'react'
import AddIcon from 'assets/images/shell/icon-add.svg'
import MoreIcon from 'assets/images/shell/icon-more.svg'

import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import {
  createTeam,
  deleteTeam,
  getTeams,
  updateTeam,
} from 'containers/Teams/Api'
import ConfirmationModal from './ConfirmationModal'
import TeamModal from './TeamsModal'

let timeout
const DEBOUNCE_DELAY = 700

function TeamsListing() {
  const [teamsList, setTeamsList] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [meta, setMeta] = React.useState({
    ...initialMetaForTable,
    perPage: 10,
  })
  const [selectedIds, setSelectedIds] = useState([])
  const [openActionId, setOpenActionId] = useState(null)
  const [isTeamModalVisible, setTeamModalVisible] = React.useState(false)
  const [refresh, setRefresh] = React.useState(false)
  const [selectedTeam, setSelectedTeam] = useState()
  const [isTeamConfirmationModalVisible, setTeamConfirmationModalVisible] =
    useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleRefresh = () => {
    setRefresh((pre) => !pre)
  }

  const handleSetPerPage = (obj) => {
    setMeta((pre) => ({ ...pre, perPage: obj.value, page: 1 }))
    handleRefresh()
  }

  const debounceFn = (callback, delay) => {
    clearTimeout(timeout)
    timeout = setTimeout(callback, delay)
  }

  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }))
    debounceFn(handleRefresh, DEBOUNCE_DELAY)
  }

  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }))
    handleRefresh()
  }

  const handleCloseModal = () => {
    setTeamModalVisible(false)
    setSelectedTeam()
  }

  const handleOpenModal = () => {
    setTeamModalVisible(true)
  }

  const fetchTeams = async () => {
    const result = await getTeams(meta.page, meta.perPage, meta.search)
    const total = result?.Total || result?.total || 0
    if (total) {
      setMeta((pre) => ({
        ...pre,
        totalCount: total,
        totalPages: Math.max(1, Math.ceil(total / meta.perPage)),
      }))
    }
    if (result?.teams) {
      const { teams } = result
      const start = (meta.page - 1) * meta.perPage
      setTeamsList(
        teams.length > meta.perPage
          ? teams.slice(start, start + meta.perPage)
          : teams
      )
    }
    setLoading(false)
  }

  const handleCreateTeam = async (values) => {
    const updatedValues = { ...values, status: 'pending' }
    const result = await createTeam(updatedValues)
    console.log(result)
    if (result?.message === 'Team created successfully') {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Team Created Successfully!'}
        />
      )
      handleRefresh()
      handleCloseModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleUpdateTeam = async (payload) => {
    /* eslint no-underscore-dangle: 0 */
    const id = payload._id
    const updatedValues = { ...payload, status: 'pending' }
    const result = await updateTeam(updatedValues, id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Team Updated Successfully!'}
        />
      )
      handleCloseModal()
      handleRefresh()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleCloseTeamConfirmationModal = () => {
    setTeamConfirmationModalVisible(false)
    setSelectedTeam()
    setIsDeleting(false)
  }

  const handleOpenTeamConfirmationModal = () => {
    setTeamConfirmationModalVisible(true)
  }

  const handleDeleteTeam = async () => {
    const result = await deleteTeam(selectedTeam._id)
    if (result?.message === 'Team deleted successfully') {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Team Deleted Successfully!'}
        />
      )
      handleRefresh()
      handleCloseTeamConfirmationModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const visibleIds = teamsList.map((item) => item._id || item.id)
  const allVisibleSelected =
    visibleIds.length > 0 && visibleIds.every((id) => selectedIds.includes(id))
  const toggleAllVisible = () => {
    setSelectedIds((current) =>
      allVisibleSelected
        ? current.filter((id) => !visibleIds.includes(id))
        : [...new Set([...current, ...visibleIds])]
    )
  }
  const toggleSelected = (id) => {
    setSelectedIds((current) =>
      current.includes(id)
        ? current.filter((item) => item !== id)
        : [...current, id]
    )
  }

  useEffect(() => {
    fetchTeams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, meta.page, meta.perPage])

  return (
    <div className='team-main'>
      <div className='container-fluid'>
        <TableWrapper
          eventFilterHeader
          footerVariant='listing'
          totalLabel='Total Teams'
          searchPlaceholder='Search...'
          setPerPage={handleSetPerPage}
          setSearchQuery={handleSetSearchQuery}
          searchValue={meta.search}
          totalListCount={meta.totalCount}
          pageSize={meta.perPage}
          currentPage={meta.page}
          onPageChange={handlePageChange}
          actionButtons={[
            {
              label: 'Add team',
              ariaLabel: 'Add team',
              icon: <img src={AddIcon} width={20} height={20} alt='' />,
              handleClick: handleOpenModal,
            },
          ]}
        >
          {loading ? (
            <p style={{ textAlign: 'center' }}>Loading</p>
          ) : (
            <table className='table team-table'>
              <thead>
                <tr>
                  <th scope='col' className='team-table__check'>
                    <input
                      type='checkbox'
                      aria-label='Select all teams'
                      checked={allVisibleSelected}
                      onChange={toggleAllVisible}
                    />
                  </th>
                  <th scope='col'>Team Name</th>
                  <th scope='col'>Objective</th>
                  <th scope='col'>Team Leader</th>
                  <th scope='col'>Facilitator</th>
                  <th scope='col' className='team-table__actions'>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {teamsList.map((item) => {
                  const itemId = item._id || item.id
                  const facilitatorNames = (item.facilitators || [])
                    .map((facilitator) => facilitator.name)
                    .filter(Boolean)
                    .join(', ')
                  return (
                    <tr key={itemId}>
                      <td className='team-table__check'>
                        <input
                          type='checkbox'
                          aria-label={`Select ${item.name || 'team'}`}
                          checked={selectedIds.includes(itemId)}
                          onChange={() => toggleSelected(itemId)}
                        />
                      </td>
                      <td>
                        <p className='team-cell' title={item.name}>
                          {item.name || 'N/A'}
                        </p>
                      </td>
                      <td>
                        <p className='team-cell' title={item.objective}>
                          {item.objective || 'N/A'}
                        </p>
                      </td>
                      <td>
                        <p className='team-cell'>{item.teamLead?.name || 'N/A'}</p>
                      </td>
                      <td>
                        <p className='team-cell'>{facilitatorNames || 'N/A'}</p>
                      </td>
                      <td className='team-table__actions'>
                        <div className='team-actions'>
                          <button
                            type='button'
                            className='team-actions__button'
                            aria-label='Team actions'
                            onClick={() =>
                              setOpenActionId((current) =>
                                current === itemId ? null : itemId
                              )
                            }
                          >
                            <img src={MoreIcon} width={20} height={20} alt='' />
                          </button>
                          {openActionId === itemId && (
                            <div className='team-actions__menu'>
                              <button
                                type='button'
                                onClick={() => {
                                  setSelectedTeam(item)
                                  setOpenActionId(null)
                                  handleOpenModal()
                                }}
                              >
                                Edit
                              </button>
                              <button
                                type='button'
                                onClick={() => {
                                  setIsDeleting(true)
                                  setSelectedTeam(item)
                                  setOpenActionId(null)
                                  handleOpenTeamConfirmationModal()
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )}
        </TableWrapper>
      </div>
      {isTeamConfirmationModalVisible && (
        <ConfirmationModal
          handleConfirmNotification={isDeleting ? handleDeleteTeam : () => {}}
          handleCloseModal={handleCloseTeamConfirmationModal}
          isDeleting={isDeleting}
          selectedNotification={selectedTeam}
        />
      )}
      {isTeamModalVisible && (
        <TeamModal
          handleCloseModal={handleCloseModal}
          selectedTeam={selectedTeam}
          handleSaveTeam={handleCreateTeam}
          handleUpdateTeam={handleUpdateTeam}
        />
      )}
    </div>
  )
}

export default TeamsListing
